import styled from 'styled-components';
import { tableCellStyles } from '../styled.js';
import { themeGet } from '../../../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../../../foundation/spacing/utils.js';
import { breakpoints } from '../../../../foundation/breakpoints/values.js';

var StyledTableBodyCell = styled.td.withConfig({
  displayName: "StyledTableBodyCell",
  componentId: "sc-k49jqa-0"
})(["", ";padding:0 ", ";line-height:1;max-width:", ";", "{padding:0 ", ";}"], tableCellStyles, themeGet('spacing.md'), function (_ref) {
  var $maxWidth = _ref.$maxWidth;
  return $maxWidth ? pxToRem($maxWidth) : '100%';
}, breakpoints.xs, themeGet('spacing.sm'));
var TableCellContent = styled.div.withConfig({
  displayName: "TableCellContent",
  componentId: "sc-k49jqa-1"
})(["display:inline-block;max-width:100%;"]);

export { StyledTableBodyCell, TableCellContent };
